import React, { useEffect, useMemo, useState } from 'react'
import redirectURL from "../redirectURL";
import { Modal } from 'react-bootstrap';
import ImageCarousel from './ImageCarousel'
import axios from 'axios'; // or use your configured redirectURL instance

export default function CheckList({ visible, onClose, data }) {
    console.log(data, "mkjl")
    const [tabOptions, setTabOptions] = useState([{ label: 'checklist', value: 'checklist' }, { label: 'checklist_images', value: 'checklist_images' }])
    const [imageUrl, setImageUrl] = useState(null);
    const [inboundurl, setInboundUrl] = useState(null)
    const [tabs, setTab ] = useState({value: "inbound"})
    const [activeTab, setActiveTab] = useState({value :'checklist'}); // default to checklist tab
    const [inboundActiveTab, setInboundActiveTab] = useState({value: "checklist"})
    const checkList = useMemo(() => [
        {
            title: "Vehicle & FO Information",
            checks: [
                { label: 'Vehicle Number', field: 'truck_no' },
                { label: 'Gate-In Status', field: 'trip_status' },
                { label: 'FO Number', field: 'fo_number' },
            ]
        },
        {
            title: 'Driver Information',
            checks: [
                { label: 'Driving License Number', field: 'driver_licence_no' },
                // { label: 'Alcohol Test', field: 'breatheTest' },
                // { label: 'Reflective Jacket Available', field: 'reflectiveJacketAvailable' },
                { label: 'Defensive Driver Training', field: 'defensiveDriverTraining' }
            ]
        },
        {
            title: 'Vehicle Documents & Worthiness',
            checks: [
                { label: 'Fitness Certificate', field: 'fitnessCertificate' },
                { label: 'PUC Certificate', field: 'pucCertificate' },
                { label: 'Insurance Certificate', field: 'insuranceCertificate' },
                { label: 'RC Certificate', field: 'registrationCerticate' },
                { label: "Seat Belts", field: "seatBelts" },
            { label: "Head Light", field: "headLight" },
            { label: "Brake Light", field: "brakeLight" },
            { label: "Side Indicator", field: "sideIndicator" },
            { label: "Brakes Working", field: "brakesWorking" },
            { label: "Vehicle Type", field: "vehicleType" },
            { label: "Front Tyre State", field: "frontTyreState" },
            { label: "Rear Tyre State", field: "rearOuterTyre" },
            { label: "Self/Ignition", field: "selfIgnition" },
            { label: "Wind Screen", field: "windScreen" },
            { label: "Wipers Working", field: "wipersWorking" },
            { label: "Rear View Mirror", field: "rearViewMirror" },
            { label: "Back Light", field: "backLight" },
            { label: "Fog Light", field: "fogLight" },
            { label: "AI Dash Camera Available", field: "aiDashCameraAvailable" },
            { label: "Working Reverse Alarm/Horn", field: "workingReverseAlarmHorn" },
            { label: "Working Reverse Camera", field: "workingReverseCamera" },
            { label: "Reflective Tape", field: "reflectiveTape" },
            { label: "RUPD/SUPD Available", field: "rupfSupdAvailable" },
            { label: "Wheel Chokes Available", field: "wheelChokesAvailable" },
            { label: "Fire Extinguisher", field: "fireExtinguisher" },
            { label: "Hazard Warning Triangle", field: "hazardWarningTriangle" },
            { label: "Inflammable Material In Driver Cabin", field: "inflammableMaterialInDriverCabin" },
            { label: "GPS Available", field: "gpsAvailable" },
            { label: "Correct Vehicle Temperature", field: "correctVehicleTemperature" },
            { label: "Water Leakage From AC Unit", field: "waterLeakageFromAcUnit" },
            { label: "Light Test", field: "lightTest" },
            { label: "Rub Test", field: "rubTest" },
            { label: "Floor/Side Test", field: "floorOrSideTest" },
            { label: "Wooden Angles Available", field: "woodenAnglesAvailable" },
            { label: "Access To Container From Driver Cabin", field: "accessToContainerFromDriverCabin" },
            { label: "Vehicle Cleanliness", field: "vehicleCleanliness" },
            { label: "Odor/Smell Observed", field: "odorSmellObserved" },
            { label: "Intact Door Locking", field: "intactDoorLocking" },
            { label: "Moisture Front", field: "selectMoistureFront" },
            { label: "Moisture Middle", field: "selectMoistureMiddle" },
            { label: "Moisture Rear", field: "selectMoistureRear" },
            { label: "No Of Tarpaulins", field: "no_of_tarpaulins" },
            { label: "Vehicle Fit For Loading", field: "vehicleFitForLoading" },
            { label: "Name Of Inspector", field: "name_of_inspector" },
                { label: 'Remarks', field: 'checklist_remarks' },
            ]
        }

    ], [])
    const inboundCheckList = useMemo(() => [
        {
            title: "Vehicle & FO Information",
            checks: [
                { label: 'Vehicle Number', field: 'truck_no' },
                { label: 'FO Number', field: 'fo_number' },
                {label: "Status", "field": "ibl_save_as_draft"},
            ]
        },
        {
            title: 'Security Details',
            checks: [
                { label: 'Accident Damaged Body', field: 'accidentDamagedBody' },
                { label: 'Head Light', field: 'iblheadLight' },
                { label: 'Brake Light', field: 'iblbrakeLight' },
                { label: 'Side Indicator', field: 'iblsideIndicator' },
                { label: 'Defensive Driver Training', field: 'ibldefensiveDriverTraining' },
                { label: 'Seal', field: 'seal' },
                { label: 'Seal Number', field: 'sealNumber' },
                { label: 'Door Gasket Checking Condition', field: 'doorGasketCheckingCondtion' },
                { label: 'One Time Lock Number', field: 'oneTimeLockNumber' },
                { label: 'Challan', field: 'challan' },
                { label: 'Challan Number', field: 'challanNumber' }
            ]
        },
        {
            title: 'Dock Details',
            checks: [
                { label: "Vehicle In Wet Condition", field: "vehicleInWetCondition" },
                { label: "Floor Tarpaulin Condition", field: "floorTarpaulinCondition" },
                { label: "Unwanted Odor / Smell", field: "unwantedOdorSmell" },
                { label: "Pest Infestation", field: "pestInfestation" },
                { label: "Holes In Vehicle", field: "holesInVehicle" },
                { label: "Wooden Angles Available", field: "iblwoodenAnglesAvailable" },
                { label: "Sharp Objects In Vehicle", field: "sharpObjectsInVehicle" },
                { label: "Dust Over Material", field: "dustOverMaterial" },
                { label: "Vehicle Cleanliness", field: "iblvehicleCleanliness" },
                { label: "Temperature At Time Of Unloading", field: "temperatureAtTimeOfUnloading" },
                { label: "Loading Pattern", field: "loadingPattern" },
                { label: "Loading Pattern Reason", field: "loadingPatternReason" },
                { label: "Any Unwanted Material", field: "anyUnwantedMaterial" }
                ]
        }

    ], [])
    const checklistData = useMemo(() => {
        const item = data || {};
        let checklist = {};
        let inbound_cl = {};
        try {
            const parsed = typeof item.checklist === 'string'  && item.checklist !== ""
                ? JSON.parse(item.checklist)
                : item.checklist;
            const inbound_checklist = typeof item.inbound_checklist === 'string'  && item.inbound_checklist !== ""
                ? JSON.parse(item.inbound_checklist)
                : item.inbound_checklist;


            checklist = Array.isArray(parsed) ? parsed[0] || {} : {};
            inbound_cl = Array.isArray(inbound_checklist) ? inbound_checklist[0] || {} : {};
        } catch (err) {
            console.error("Error parsing checklist:", err);
        }
        return {
            ...checklist,
            ...inbound_cl,
            truck_no: item.truck_no ?? '-',
            driver_licence_no: item.driver_licence_no ?? '-',
            gate_in_type : item.gate_in_type ??'-',
            fo_number : item.fo_number ?? '-',
            trip_status: item.trip_status ?? '-',
            name_of_inspector: item.name_of_inspector ?? '-',
            no_of_tarpaulins: item.no_of_tarpaulins ?? '-',
            checklist_remarks: item.checklist_remarks ?? '-',
            ibl_save_as_draft: item.ibl_save_as_draft ?? '-'
        }
    }, [data]);
    const handleTabChange = (value) => {
        // setTabOptions({ value });
        setActiveTab({value})
    };
    const handleInboundTabChange = (value)=>{
        setInboundActiveTab({value})
        setActiveTab({value :'checklist'})
    }
    const modalClose = ()=>{
        setActiveTab({value :"checklist"})
        setInboundActiveTab({value :"checklist"})
        setImageUrl(null)
        onClose()

    }

    const tabChange = (value)=>{
        console.log("tab changes", value)
        setTab({value})
    }

    useEffect(() => {
        if (visible && ((Array.isArray(data?.checklist_files) && data.checklist_files.length) || (Array.isArray(data?.gatein_files) && data.gatein_files.length))) {
            checklistImages();
        }
}, [data?.checklist_files, visible, data?.gatein_files]);

useEffect(() => {
        if (visible && ((Array.isArray(data?.inbound_checklist_files) && data.inbound_checklist_files.length))) {
            inboundchecklistImages();
        }
}, [data?.inbound_checklist_files, visible]);
    const checklistImages = () => {
        try {
            let param = {}
            if ((Array.isArray(data.checklist_files) && data.checklist_files.length)|| (Array.isArray(data?.gatein_files) && data.gatein_files.length)) {
                if(Array.isArray(data.checklist_files) && data.checklist_files.length){
                    param = {
                    fileName: data.checklist_files
                };
                }
                else{
                    param = {
                    fileName: data.gatein_files
                }}
                

                redirectURL.post('/getChecklistImages', param)
                    .then(response => {
                        if (response.data.message === "Success") {
                            const urls = response.data?.data?.map(item => item.url);
                            setImageUrl(urls);
                        } else {
                            setImageUrl([]);
                        }
                    })
                    .catch(err => {
                        setImageUrl([]);
                    });
            } else {
                setImageUrl([]);
            }
        } catch (e) {
            setImageUrl([]);
        }
    }

    const inboundchecklistImages = () => {
        try {
            let param = {}
            if ((Array.isArray(data.inbound_checklist_files) && data.inbound_checklist_files.length)) {
                if(Array.isArray(data.inbound_checklist_files) && data.inbound_checklist_files.length){
                    param = {
                    fileName: data.inbound_checklist_files
                };
                }
                

                redirectURL.post('/getChecklistImages', param)
                    .then(response => {
                        if (response.data.message === "Success") {
                            const urls = response.data?.data?.map(item => item.url);
                            setInboundUrl(urls);
                        } else {
                            setInboundUrl([]);
                        }
                    })
                    .catch(err => {
                        setInboundUrl([]);
                    });
            } else {
                setInboundUrl([]);
            }
        } catch (e) {
            setInboundUrl([]);
        }
    }
    return (
        <>
            {visible && ( <Modal
                onHide={modalClose}
                dialogClassName="checklist_modal"
                show={visible}
                centered>
                <Modal.Header>
                    <Modal.Title>View Checklist</Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={modalClose}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className='checklist_modal_body'>
                    <div className="check_list">
                    <div className="tabs">
                                <div className="col-xl-12 px-0">
                                    <button
                                        onClick={() => { tabChange('inbound') }}
                                        className={(tabs.value == "inbound") ? "btn btn-info f14" : "btn tab-btn f14"}
                                    >
                                        Inbound
                                    </button>
                                    <button
                                        onClick={() => { tabChange('outbound') }}
                                        className={(tabs.value == "outbound") ? "btn btn-info f14" : "btn tab-btn f14"}
                                    >
                                        Outbound
                                    </button>
                                </div>
                    </div>
                    {tabs.value == "outbound" && 
                    <div className="tabs">
                                <div className="col-xl-12 px-0">
                                    <button
                                        onClick={() => { handleTabChange('checklist') }}
                                        className={(activeTab.value == "checklist") ? "btn btn-info f14" : "btn tab-btn f14"}
                                        style={{
                                            display: (activeTab.value == "checklist") ? "inline-flex" : ""
                                        }}
                                    >
                                        Checklist
                                    </button>
                                    <button
                                        onClick={() => { handleTabChange('checklist_images') }}
                                        className={(activeTab.value == "checklist_images") ? "btn btn-info f14" : "btn tab-btn f14"}
                                        style={{
                                            display: (activeTab.value == "checklist_images") ? "inline-flex" : ""
                                        }}
                                    >
                                        Checklist Images
                                    </button>
                                </div>
                    </div>
                    }
                    {tabs.value == "inbound" && 
                    <div className="tabs">
                                <div className="col-xl-12 px-0">
                                    <button
                                        onClick={() => { handleInboundTabChange('checklist') }}
                                        className={(inboundActiveTab.value == "checklist") ? "btn btn-info f14" : "btn tab-btn f14"}
                                        style={{
                                            display: (inboundActiveTab.value == "checklist") ? "inline-flex" : ""
                                        }}
                                    >
                                        Checklist
                                    </button>
                                    <button
                                        onClick={() => { handleInboundTabChange('checklist_images') }}
                                        className={(inboundActiveTab.value == "checklist_images") ? "btn btn-info f14" : "btn tab-btn f14"}
                                        style={{
                                            display: (inboundActiveTab.value == "checklist_images") ? "inline-flex" : ""
                                        }}
                                    >
                                        Checklist Images
                                    </button>
                                </div>
                    </div>
                    }
                            <div className='table-wrapper'>
                             {activeTab.value == 'checklist' && tabs.value == "outbound" ? (<div ><table style={{ width: '100%' }}>
                                <thead><tr className='table_headers'>
                                    <th className='modal_head' style={{ width: '258px' }}>Particulars</th>
                                    <th className='modal_head'>Activities</th>
                                    <th className='modal_head'>Status</th></tr></thead>
                                <tbody>
                                    {checkList.map((section, secIndex) => (
                                        section.checks.map((check, checkIndex) => (
                                            <tr key={check.field}>
                                                {checkIndex === 0 ? (
                                                    <td rowSpan={section.checks.length} style={{ verticalAlign: 'middle', fontWeight: 'bold' }}>
                                                        {section.title}
                                                    </td>
                                                ) : null}
                                                <td className='table_label'>{check.label}
                                                    {['fitnessCertificate', 'pucCertificate', 'insuranceCertificate', 'registrationCerticate', 'seatBelts', 'headLight', 'brakeLight', 'sideIndicator', 'brakesWorking', 'driver_licence_no', 'defensiveDriverTraining', 'vehicleType', 'fo_number', 'truck_no', 'name_of_inspector'].includes(check.field) && (
                                                        <span style={{ color: 'red',fontSize:"1rem" }}> *</span>
                                                    )}
                                                </td>
                                                <td style={
                                                    check.field === 'trip_status'
                                                        ? checklistData[check.field] === 'Approved'
                                                            ? { color: '#28a745', fontWeight: 'bold' }  // green
                                                            : checklistData[check.field] === 'Rejected' ?{ color: '#dc3545', fontWeight: 'bold' }:checklistData[check.field] == 'Pending for approval'?{ color: '#ef8816', fontWeight: 'bold' }:{}  // red
                                                        : {}
                                                }>{checklistData[check.field] ?? "-"}</td>
                                            </tr>
                                        ))
                                    ))}
                                </tbody>
                            </table></div>) : activeTab.value == "checklist_images" && tabs.value == "outbound" ? (<><div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80%' }}>
                                <ImageCarousel data={imageUrl} />
                            </div></>

                            ): tabs.value == "inbound" && inboundActiveTab.value == "checklist"?
                            ((<div ><table style={{ width: '100%' }}>
                                <thead><tr className='table_headers'>
                                    <th className='modal_head' style={{ width: '258px' }}>Particulars</th>
                                    <th className='modal_head'>Activities</th>
                                    <th className='modal_head'>Status</th></tr></thead>
                                <tbody>
                                    {inboundCheckList.map((section, secIndex) => (
                                        section.checks.map((check, checkIndex) => (
                                            <tr key={check.field}>
                                                {checkIndex === 0 ? (
                                                    <td rowSpan={section.checks.length} style={{ verticalAlign: 'middle', fontWeight: 'bold' }}>
                                                        {section.title}
                                                    </td>
                                                ) : null}
                                                <td className='table_label'>{check.label}
                                                    {['sealNumber', 'challanNumber']
.includes(check.field) && (
                                                        <span style={{ color: 'red',fontSize:"1rem" }}> *</span>
                                                    )}
                                                </td>
                                                <td style={
                                                    check.field === 'ibl_save_as_draft'
                                                        ? checklistData[check.field] === 'Submitted'
                                                            ? { color: '#28a745', fontWeight: 'bold' }  // green
                                                            : { color: '#ef8816', fontWeight: 'bold' }:{}
                                                }>{checklistData[check.field] ?? "-"}</td>
                                            </tr>
                                        ))
                                    ))}
                                </tbody>
                            </table></div>)):
                            (<><div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80%' }}>
                                <ImageCarousel data={inboundurl} />
                            </div></>)
                            }</div></div>
                </Modal.Body>
            </Modal>
                )}</>
    )
}
